import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { slideInAnimation } from '@shared/animations/swipe';
import { FaqService, GuardService } from '@shared/services';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    animations: [slideInAnimation],
    standalone: false
})
export class MainComponent implements OnInit {
    constructor(
        private faqService: FaqService,
        private guardService: GuardService
    ) {}

    ngOnInit() {
        if (this.guardService.isActive) {
            this.faqService.getAll();
        }
    }

    prepareRoute(outlet: RouterOutlet) {
        return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
    }
}
